import { axiosPatch } from '@/api/handlers';
import { useMutation } from '@/api/hooks';

import { InitializePasswordSchema } from '../_models/initialize-password';

export const useInitializePassword = () => {
  return useMutation({
    mutationFn: async (data: { token: string; newPassword: string }) => {
      const payload = InitializePasswordSchema.parse(data);
      return await axiosPatch(
        '/api/users/settings/password/with-token/',
        payload,
      );
    },
  });
};
